import { GetKitDto } from "@/lib/gen-api";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faBooks,
  faComment,
  faFiles,
  faHeadSide,
  faLayerGroup,
  faPalette,
  faPuzzle,
  faPuzzlePiece,
  faShapes,
  faUserTie,
  faWandMagicSparkles,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";

export const ARTIFACT_DEFAULT_ICON: IconDefinition = faPuzzlePiece;

export const getDefaultKitIcon = (kit: Pick<GetKitDto, "type">) => {
  const typeToIcon: Record<GetKitDto["type"], IconDefinition> = {
    conversation: faComment,
    expert: faHeadSide,
    skill: faWandMagicSparkles,
    template: faPalette,
    repository: faBooks,
    project: faFiles,
    project_preset: faShapes,
    interview: faUserTie,
    collection: faLayerGroup,
  };

  return kit.type in typeToIcon ? typeToIcon[kit.type] : faPuzzle;
};

export const getDefaultKitColorClassName = (kit: Pick<GetKitDto, "type">) => {
  const typeToColor: Record<GetKitDto["type"], string> = {
    conversation: "text-blue-500",
    expert: "text-purple-500",
    skill: "text-pink-500",
    template: "text-yellow-500",
    repository: "text-purple-500",
    project: "text-gray-500",
    project_preset: "text-grey-500",
    interview: "text-teal-500",
    collection: "text-indigo-500",
  };

  return kit.type in typeToColor ? typeToColor[kit.type] : "text-gray-500";
};
